const header = document.querySelector('.js-header');
const anchors = Array.from(document.querySelectorAll('.js-text-default__anchor'));

anchors.forEach((anchor) => {
	anchor.addEventListener('click', (e) => {
		e.preventDefault();

		const anchorId = anchor.getAttribute('href');
		const anchorBlock = document.querySelector(anchorId);
		const headerHeight = header.offsetHeight;

		if (anchorBlock) {
			window.scroll({
				behavior: 'smooth',
				top: anchorBlock.offsetTop - headerHeight - 20, // 20px это чисто отступ от шапки
			});
		}
	});
});

const isVisible = (el) => {
	var rect = el.getBoundingClientRect();
	var viewHeight = window.innerHeight;

	return !(rect.top - viewHeight / 2 >= 0);
};

const timerId = null;

window.addEventListener('scroll', () => {
	clearTimeout(timerId);

	setTimeout(() => {
		let activeIndexOfAnchor = 0;

		anchors.forEach((anchor, index) => {
			const anchorId = anchor.getAttribute('href');
			const anchorBlock = document.querySelector(anchorId);

			if (anchorBlock) {
				anchor.classList.remove('active');

				if (isVisible(anchorBlock)) {
					activeIndexOfAnchor = index;
				}

				const isLastIteration = index === anchors.length - 1;

				if (isLastIteration) {
					anchors[activeIndexOfAnchor].classList.add('active');
				}
			}
		});
	}, 150);
});
